import React from 'react';
import FormControl from '@mui/material/FormControl';
import FormHelperText from '@mui/material/FormHelperText';
import Switch from '@mui/material/Switch';
import FormControlLabel from '@mui/material/FormControlLabel';

const FormToggle = ({
  color = 'primary',
  name = '',
  title,
  onChange,
  children,
  size = 'small',
  variant = 'filled',
  formik: {
    values = {},
    errors = {},
    handleChange
  }
}) => {
  return /*#__PURE__*/React.createElement(FormControl, {
    color: color,
    variant: variant,
    fullWidth: true,
    focused: true,
    sx: {
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'center',
      height: '100%',
      pl: 2
    }
  }, /*#__PURE__*/React.createElement(FormControlLabel, {
    control: /*#__PURE__*/React.createElement(Switch, {
      checked: values[name],
      onChange: async e => {
        if (handleChange) await handleChange(e);
        if (onChange) await onChange(e);
      },
      name: name,
      size: size
    }),
    label: title || name
  }), errors[name] && /*#__PURE__*/React.createElement(FormHelperText, {
    error: true
  }, errors[name]), children);
};

export { FormToggle };
